/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-07-09 17:44:37 
 * @Last Modified by:   syyoon@yongtrim.com 
 * @Last Modified time: 2018-07-09 17:44:37 
 */

import { Action } from '@ngrx/store';

import { User } from '../../models/user.model';

export const TRYLOGIN = '[Auth] TRYLOGIN';
export const TRYLOGIN_SUCCESS = '[Auth] TRYLOGIN_SUCCESS';
export const TRYLOGIN_ERROR = '[Auth] TRYLOGIN_ERROR';

export const LOGIN = '[Auth] LOGIN';
export const LOGIN_SUCCESS = '[Auth] LOGIN_SUCCESS';
export const LOGIN_ERROR = '[Auth] LOGIN_ERROR';

export const LOGOUT = '[Auth] LOGOUT';

export const UPDATE_AUTH_RECEIVED = '[Auth] UPDATE_AUTH_RECEIVED';


export class TryLogin implements Action {
  readonly type = TRYLOGIN;
}
export class TryLoginSuccess implements Action {
  readonly type = TRYLOGIN_SUCCESS;
  constructor(public user: User) { }
}
export class TryLoginError implements Action {
  readonly type = TRYLOGIN_ERROR;
}


export class Login implements Action {
  readonly type = LOGIN;
  constructor(public phone: string, public password: string, public snsId: string, public provider: string) { }
}
export class LoginSuccess implements Action {
  readonly type = LOGIN_SUCCESS;
  constructor(public user: User, public token: string) { }
}
export class LoginError implements Action {
  readonly type = LOGIN_ERROR;
}


export class Logout implements Action {
  readonly type = LOGOUT;
}


export class UpdateAuthReceived implements Action {
  readonly type = UPDATE_AUTH_RECEIVED;
  constructor(public user: User) { }
}


export type All =
  Login | LoginSuccess | LoginError |
  TryLogin | TryLoginSuccess | TryLoginError |
  Logout |
  UpdateAuthReceived;



// WEBPACK FOOTER //
// ./src/store/auth/auth.action.ts